export default __webpack_public_path__ + "static/media/main3_m.b73e57be.jpg";